import { useEffect } from "react";
import { useWalletObserver } from "@sundaeswap/wallet-lite";
import { x25519 } from "@noble/curves/ed25519";
import * as ed from "@noble/ed25519";
import { hkdf } from "@noble/hashes/hkdf.js";
import { randomBytes } from "@noble/hashes/utils.js";
import { sha256 } from "@noble/hashes/sha2.js";

import { ensureEphemeralWallet } from "@/lib/ephemeralWallet";
import { useAppContext } from "@/context/AppContext";
import { AppActions } from "@/context/AppContext/AppActions";

export function useOrderEncryptionHandshake() {
  const { mainAddress } = useWalletObserver();
  const { dispatch } = useAppContext();

  useEffect(() => {
    const doHandshake = async () => {
      // Only real wallets need an order-signing ephemeral wallet; guests
      // (no mainAddress) only read market data over the encrypted channel.
      if (mainAddress) {
        await ensureEphemeralWallet(mainAddress);
      }
      const sessionKeys = x25519.keygen();

      const hkdfSalt = randomBytes(32);

      const response = await fetch(`${window.__APP_CONFIG.apiBaseUrl}/handshake`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_session_public_key: sessionKeys.publicKey.toHex(),
        }),
      });

      if (!response.ok) {
        throw new Error(`Ledger handshake failed with status ${response.status}`);
      }

      const json = await response.json();
      const responsePublicKey = Uint8Array.fromHex(json.report_data.slice(64));
      const sharedSecret = x25519.getSharedSecret(sessionKeys.secretKey, responsePublicKey);

      const info = new TextEncoder().encode(
        `SUGAR-RUSH-ORDERBOOK-REQUEST-V1-${sessionKeys.publicKey.toHex()}`,
      );

      const encryptionKey = hkdf(sha256, sharedSecret, hkdfSalt, info, 32);

      AppActions.setOrderEncryptionKey({ session: sessionKeys, encryption: encryptionKey, hkdfSalt }, dispatch);
    };

    doHandshake();
  }, [mainAddress, dispatch]);
}
